import React, { useEffect, useState, useRef } from "react"
import { useRouter } from "next/router"
import { CSVLink } from "react-csv"
import {
  HomeIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
  AdjustmentsHorizontalIcon,
  UsersIcon,
  TruckIcon,
  UserPlusIcon,
  UserGroupIcon,
  ArchiveBoxArrowDownIcon,
  UserIcon,
  DocumentArrowDownIcon,
  CalendarDaysIcon,
  ShareIcon,
} from "@heroicons/react/24/outline"
import {
  Localstorage,
  convertEquipmentType,
  dateFormat,
  dateFormat1,
  dollarUS,
} from "@/lib/services"
import { LocalStorage } from "@/lib/types/LocalStorage"
import { Modal } from "../general/Modal"
import { useMutation } from "react-query"
import { api } from "@/lib/api"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { Order } from "@/lib/types"
import Link from "next/link"
import Swal from "sweetalert2"

export const DashboardSidebar = () => {
  const router = useRouter()
  const { pathname } = useRouter()
  const [userPopup, setUserPopup] = useState(false)
  const csvLinkElement1 = useRef<any>(null)
  const csvLinkElement2 = useRef<any>(null)
  const [data, setData] = useState([])
  const [isDataReadyButton1, setIsDataReadyButton1] = useState(false)
  const [isDataReadyButton2, setIsDataReadyButton2] = useState(false)
  const user = Localstorage.get<LocalStorage>("next.user")
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState<Date | null>(null)
  const onChange = (dates: [Date, Date]) => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }

  const handleDownloadPopup = () => {
    setUserPopup(true)
  }

  const order = [
    {
      label: "Date",
      key: "date",
    },
    {
      label: "User",
      key: "user",
    },
    {
      label: "Origin",
      key: "origin",
    },
    {
      label: "Destination",
      key: "destination",
    },
    {
      label: "Equipment",
      key: "equip",
    },
    {
      label: "Pickup Date",
      key: "pickDate",
    },
    {
      label: "Cost",
      key: "cost",
    },
    {
      label: "Quoted",
      key: "price",
    },
  ]
  const deliveryOrder = [
    {
      label: "Date",
      key: "date",
    },
    {
      label: "User",
      key: "user",
    },
    {
      label: "Origin",
      key: "origin",
    },
    {
      label: "Destination",
      key: "destination",
    },
    {
      label: "Equipment",
      key: "equip",
    },
    {
      label: "Pickup Date",
      key: "pickDate",
    },
    {
      label: "Delivery Date",
      key: "deliveryDate",
    },
    {
      label: "Method",
      key: "method",
    },
    {
      label: "Cost",
      key: "cost",
    },
    {
      label: "Quoted",
      key: "quoted",
    },
  ]

  const downloadCSVOne = async () => {
    mutationDeliveries.mutate()
  }

  const downloadCSVTwo = () => {
    mutationQuotesParams.mutate()
  }
  const mutationDeliveries = useMutation(
    () => {
      return api.OrdersApi.RecentOrder({
        input: "",
        page: 1,
        startDate: dateFormat1(dateFormat(startDate)) as any,
        endDate: dateFormat1(
          dateFormat(endDate !== null ? endDate : startDate),
        ) as any,
      })
    },
    {
      onSuccess: async (data) => {
        if (data && data.deliveries && data.deliveries.length > 0) {
          const formattedData = data.deliveries.map((e: Order) => ({
            date: dateFormat1(e.pickupDate),
            user: `${e.user?.firstName} ${e.user?.lastName}`,
            origin: e.origin,
            destination: e.destination,
            equip: convertEquipmentType(e.equipment),
            pickDate: dateFormat1(e.pickupDate),
            deliveryDate: dateFormat1(e.deliveryDate),
            method: e.method,
            cost: dollarUS.format(e.cost),
            quoted: dollarUS.format(e.price),
          }))
          setData(formattedData)
          setIsDataReadyButton1(true)
        } else {
          Swal.fire({
            icon: "info",
            title: "No Deliveries Found",
            text: "There are no deliveries for the selected date range.",
            confirmButtonColor: "#CEA16B",
            confirmButtonText: "OK",
            iconColor: "#CEA16B",
            customClass: {
              popup: "custom-success-popup",
            },
          });

        }
      },
    },
  )

  const mutationQuotesParams = useMutation(
    () => {
      return api.OrdersApi.RecentQuotesParams({
        page: -1,
        startDate: dateFormat1(dateFormat(startDate)) as any,
        endDate: dateFormat1(
          dateFormat(endDate !== null ? endDate : startDate),
        ) as any,
      })
    },
    {
      onSuccess: async (data) => {
        if (data && data.quotes && data.quotes.length > 0) {
          const formateData = data.quotes.map((e: Order) => ({
            date: dateFormat1(e.pickupDate),
            user: `${e.user?.firstName} ${e.user?.lastName}`,
            origin: e.origin,
            destination: e.destination,
            equip: convertEquipmentType(e.equipment),
            pickDate: dateFormat1(e.pickupDate),
            cost: dollarUS.format(e.cost),
            price: dollarUS.format(e.price),
          }))
          setData(formateData)
          setIsDataReadyButton2(true)
        } else {
          Swal.fire({
            icon: "info",
            title: "No Quotes Found",
            text: "There are no quotes for the selected date range.",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
          });
        }
      },
    },
  )



  useEffect(() => {
    if (data.length > 0) {
      if (isDataReadyButton1 && csvLinkElement1 && csvLinkElement1.current) {
        csvLinkElement1.current.link.click()
        setIsDataReadyButton1(false)
      }
      if (isDataReadyButton2 && csvLinkElement2 && csvLinkElement2.current) {
        csvLinkElement2.current.link.click()
        setIsDataReadyButton2(false)
      }
    }
  }, [data])

  const SideBarItems = [
    // Customer
    {
      id: 1,
      title: "Home",
      icon: HomeIcon,
      link: ["/customer-dashboard"],
      role: ["CUSTOMER"],
      slug: "customer-dashboard",
      cls: "before:content-['Home']",
    },
    {
      id: 2,
      title: "Recent Activities",
      icon: ArchiveBoxArrowDownIcon,
      link: ["/recent-activities?pageNum=1&&quotespageNum=1&input="],
      role: ["CUSTOMER"],
      slug: "recent-activities",
      cls: "before:content-['Recent_Activities']",
    },
    {
      id: 5,
      title: "Shared Quoted",
      slug: "shared-quoted",
      icon: ShareIcon,
      link: ["/shared-quoted"],
      role: ["CUSTOMER"],
      cls: "before:content-['Shared_Quoted']",
    },
    {
      id: 3,
      title: "User Profile",
      icon: UserCircleIcon,
      link: ["/user-profile"],
      role: ["CUSTOMER"],
      slug: "user-profile",
      cls: "before:content-['User_Profile']",
    },
    // Admin
    {
      id: 4,
      title: "Dashboard",
      slug: "/admin-dashboard",
      icon: HomeIcon,
      link: ["/admin-dashboard"],
      role: ["ADMIN"],
      cls: "before:content-['Dashboard']",
    },
    {
      id: 5,
      title: "Recent Activities",
      slug: "recent-activities",
      icon: ArchiveBoxArrowDownIcon,
      link: ["/recent-activities?pageNum=1&&quotespageNum=1&input="],
      role: ["ADMIN"],
      cls: "before:content-['Recent_Activities']",
    },

    {
      id: 6,
      title: "Customer Dashboard",
      icon: TruckIcon,
      link: ["/customer-dashboard"],
      role: ["ADMIN"],
      slug: "customer-dashboard",
      cls: "before:content-['Customer_Dashbaord']",
    },
    // {
    //   id: 7,
    //   title: "Sales Dashboard Old",
    //   icon: UsersIcon,
    //   link: ["/sales-dashboard-old"],
    //   role: ["ADMIN"],
    //   slug: "sales-dashboard",
    //   cls: "before:content-['Sales_Dashboard']",
    // },
    {
      id: 20,
      title: "Sales Dashboard",
      icon: UsersIcon,
      link: ["/sales-dashboard"],
      role: ["ADMIN"],
      slug: "sales-dashboard",
      cls: "before:content-['Sales_Dashboard']",
    },
    {
      id: 8,
      title: "Assign Users",
      icon: UserPlusIcon,
      link: ["/assign-users"],
      role: ["ADMIN"],
      slug: "assign-users",
      cls: "before:content-['Assign_Users']",
    },
    {
      id: 9,
      title: "Settings",
      icon: AdjustmentsHorizontalIcon,
      link: [
        "/port-of-entry",
        "/carrier",
        "/transload-partner",
        "/carrier-rates",
        "/contract-rates",
        "/direct-rates",
        "/spot-rate",
        "/spot-rates-modifier",
        "/search-page",
        "/update-maps-data",
        "/mexico-market",
        "/daily-mileage",
        "/users?pageNum=1&input=",
        "/margin-percentage",
        "/capacity-type",
        "/customer-contract-rates",
        "/holiday-modifier",
        "/lead-time-modifier",
        "/mci-table",
        "/organization-credentials",
        "/rate-engine-weight",
        "/same-day-modifier",
        "/small-truck-rates",
        "/weekend-modifier",
        "/users",
      ],
      role: ["ADMIN"],
      slug: "settings",
      cls: "before:content-['Settings']",
    },
    {
      id: 10,
      title: "Settings",
      icon: UserCircleIcon,
      link: ["/user-profile"],
      role: ["ADMIN"],
      slug: "user-profile",
      cls: "before:content-['User_Profile']",
    },
    {
      id: 11,
      title: "Download",
      icon: DocumentArrowDownIcon,
      link: [" "],
      role: ["ADMIN"],
      slug: "download",
      cls: "before:content-['Download']",
    },
    // Sales Rep
     {
      id: 13,
      title: "Admin Dashboard",
      icon: UserIcon,
      link: ["/admin-dashboard"],
      role: ["SALESREP"],
      slug: "admin_dashbaord",
      cls: "before:content-['Admin_Dashboard']",
    },
    {
      id: 12,
      title: "Sales Dashboard",
      icon: HomeIcon,
      link: ["/sales-dashboard"],
      role: ["SALESREP"],
      slug: "sales_dashboard",
      cls: "before:content-['Sales_Dashboard']",
    },
   
    {
      id: 18,
      title: "Customer Dashboard",
      icon: TruckIcon,
      link: ["/customer-dashboard"],
      role: ["SALESREP"],
      slug: "customer-dashboard",
      cls: "before:content-['Customer_Dashbaord']",
    },
    {
      id: 14,
      title: "Recent Activities",
      icon: ArchiveBoxArrowDownIcon,
      link: ["/recent-activities?pageNum=1&&quotespageNum=1&input="],
      role: ["SALESREP"],
      slug: "recent-activities",
      cls: "before:content-['Recent_Activities']",
    },
    {
      id: 25,
      title: "Assign Users",
      icon: UserPlusIcon,
      link: ["/assign-users"],
      role: ["SALESREP"],
      slug: "assign-users",
      cls: "before:content-['Assign_Users']",
    },
    {
      id: 16,
      title: "Recent Users",
      icon: UserGroupIcon,
      link: [`/users?pageNum=1&input=`],
      role: ["SALESREP"],
      slug: "users",
      cls: "before:content-['Recent_Users']",
    },
    {
      id: 17,
      title: "User Profile",
      icon: UserCircleIcon,
      link: ["/user-profile"],
      role: ["SALESREP"],
      slug: "user-profile",
      cls: "before:content-['User_Profile']",
    },
  ]

  const logout = () => {
    Localstorage.remove("next.user")
    Localstorage.remove("next.token")
    Localstorage.remove("re_quote")
    Localstorage.remove("re_quote_equip")
    router.push("/")
  }
  const isActiveLink = (pathname: string, links: string[], name: string) => {
    const pathSegments = pathname.split("/")
    return (
      links.some((link) => pathname.includes(link)) ||
      pathSegments.includes(name.toLowerCase())
    )
  }

  return (
    <>
      <Modal
        close={() => setUserPopup(false)}
        open={userPopup}
        width="x-small"
        title="Download"
      >
        <div className="flex flex-col gap-3 items-center">
          <div className="w-full">
            <h5 className="text-xs dark:text-primary-8 text-light-1 mb-0.5">
              Select Date
            </h5>
            <DatePicker
              className="dark:bg-transparent bg-white dark:text-white text-zinc-600 border-2 dark:border-secondary-2 rounded outline-none md:w-full w-100"
              showIcon
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              dateFormat="MM/dd/yyyy"
              icon={<CalendarDaysIcon className="text-accent w-full" />}
            />
          </div>
          <div className="w-full">
            <h5 className="text-xs dark:text-primary-8 text-light-1">
              Recent Deliveries
            </h5>
            <button
              className="w-full bg-primary-8 dark:text-secondary-2 text-primary-1 px-4 py-2 rounded font-medium mt-2"
              onClick={() => downloadCSVOne()}
            >
              {mutationDeliveries.isLoading ? `Downloading...` : `Downlaod`}
            </button>
            <CSVLink
              headers={deliveryOrder}
              filename="recent_deliveries.csv"
              data={data}
              ref={csvLinkElement1}
            />
          </div>
          <div className="w-full">
            <h5 className="text-xs dark:text-primary-8 text-light-1">Quotes</h5>
            <button
              className="w-full bg-primary-8 dark:text-secondary-2 text-primary-1 px-4 py-2 rounded font-medium mt-2"
              onClick={() => downloadCSVTwo()}
            >
              {mutationQuotesParams.isLoading ? `Downloading...` : `Downlaod`}
            </button>
            <CSVLink
              headers={order}
              filename="recent_quotes.csv"
              data={data}
              ref={csvLinkElement2}
            />
          </div>
        </div>
      </Modal>
      <div className="md:w-20 w-16 fixed bottom-0 flex flex-col dark:bg-secondary-8 border-r-2 dark:border-secondary-7 sidebar-height z-[2]">
        <div className="flex flex-col py-4 dark:text-primary-10">
          {SideBarItems.map((item) =>
            item.role.includes(user?.role as string) ? (
              <Link
                className="sidebar-btn md:p-4 p-3 group hover:bg-primary-8 rounded-md relative"
                href={item.link[0]}
                key={item.id}
              >
                <div
                  className={"cst-tooltip group " + item.cls}
                  onClick={() => {
                    if (item.title === "Download") {
                      handleDownloadPopup()
                    } else {
                      router.push(item.link[0])
                    }
                  }}
                >
                  <item.icon
                    className={
                      (isActiveLink(pathname, item.link, item.slug)
                        ? "text-accent"
                        : "dark:text-white text-gray-700") +
                      " h-6 w-6 mx-auto dark:hover:text-secondary-2 hover:text-primary-1 dark:group-hover:text-secondary-2 group-hover:text-primary-1 z-50"
                    }
                  />
                </div>
              </Link>
            ) : null,
          )}
        </div>

        <div
          onClick={logout}
          title="Logout"
          className="p-4 mt-auto cursor-pointer"
        >
          <ArrowRightOnRectangleIcon className="h-7 w-7 mx-auto dark:text-primary-10 text-gray-700" />
        </div>
      </div>
    </>
  )
}

export default DashboardSidebar
